import setUserToDelete from '../actions/setUserToDelete.js'

export default [setUserToDelete]



// WEBPACK FOOTER //
// ./src/modules/user/chains/askUserDelete.js